import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import Image from 'app/Components/Shared/Image/image';
import BtnSubmit from '../../../../Shared/Buttons/BtnSubmit';
import Support from '../../Partials/Support/Support';
import GetQrCodeErrorPopUp from '../../Partials/GetQrCodeErrorPopUp/GetQrCodeErrorPopUp';
import { goToPage, setIsGetQrCodeError, reportDWH } from '../../EsimQrCodeBlockSlice';
import { getQrCodeAsync } from '../../EsimQrCodeBlockAsyncThunk';
import qrIcon from './images/qr-icon.svg';
import './InstallEsimOnMobilePage.scss';

const openUniversalLink = (url) => {
    if (!url) {
        return;
    }

    window.open(url, '_blank', 'noopener,noreferrer');
};

const hasUniversalLinks = (appleUniversalLink, androidUniversalLink) =>
    Boolean(appleUniversalLink || androidUniversalLink);

const InstallEsimOnMobilePage = (props) => {
    const hasFetchedOnMount = useRef(false);

    useEffect(() => {
        props.reportDWH({
            actionType: 'eSIM Auto Activation Page',
            status: 'Ongoing',
            messageText: 'eSIM Auto Activation Page Displayed',
        });

        if (hasFetchedOnMount.current) {
            return;
        }

        hasFetchedOnMount.current = true;

        if (!hasUniversalLinks(props.appleUniversalLink, props.androidUniversalLink)) {
            loadActivationData();
        }
    }, []);

    return (
        <div className='install-esim-on-mobile-page-wrapper'>
            <div className='install-esim-on-mobile-page'>
                <div className='install-esim-on-mobile-page__content'>
                    <div className='title'>הפעלת eSIM</div>
                    <div className='sub-title'>קו מספר {props.subscriberNo}</div>
                    <div className='instructions'>
                        להפעלה אוטומטית של ה-eSIM יש ללחוץ על סוג המכשיר הרלוונטי
                    </div>

                    <div className='auto-activation-buttons'>
                        <BtnSubmit
                            className='install-esim-btn install-esim-btn--android'
                            text='אנדרואיד'
                            type='button'
                            onclick={() => handleUniversalLinkActivation('android')}
                            formid='esim-qr-code-block'
                            isDisplayArrows={false}
                            isDisplayWhatsAppIcon={false}
                            disabled={props.isLoadingQrCode}
                        />
                        <BtnSubmit
                            className='install-esim-btn install-esim-btn--ios'
                            text='iOS'
                            type='button'
                            onclick={() => handleUniversalLinkActivation('ios')}
                            formid='esim-qr-code-block'
                            isDisplayArrows={false}
                            isDisplayWhatsAppIcon={false}
                            disabled={props.isLoadingQrCode}
                        />
                    </div>

                    <div className='link-wrapper link-wrapper--qr'>
                        <a href='#' className='qr-link' onClick={handleQrActivation}>
                            <Image src={qrIcon} alt='' className='qr-link__icon' />
                            <span className='qr-link__text'>להפעלה באמצעות QR</span>
                        </a>
                    </div>
                    <div className='seperator'></div>
                </div>

                <Support />
            </div>

            <GetQrCodeErrorPopUp
                show={props.isGetQrCodeError}
                onClose={handleErrorPopupClose}
            />
        </div>
    );

    async function loadActivationData() {
        await props.getQrCodeAsync({ isDisplayLoader: true });
    }

    function handleErrorPopupClose() {
        props.setIsGetQrCodeError(false);
        loadActivationData();
    }

    function handleUniversalLinkActivation(platform) {
        props.reportDWH({
            actionType: 'eSIM Auto Activation Page',
            status: 'Ongoing',
            messageText: platform === 'android' ? 'Android Activation Button Clicked' : 'iPhone Activation Button Clicked',
        });

        const link = platform === 'android'
            ? props.androidUniversalLink
            : props.appleUniversalLink;

        if (link) {
            openUniversalLink(link);
        } else {
            props.reportDWH({
                actionType: 'Auto Activation',
                status: 'Error',
                messageText: 'General Error',
            });
        }
    }

    function handleQrActivation(e) {
        e.preventDefault();
        props.goToPage('instructionsPage');
    }
};

const mapStateToProps = (state) => {
    return {
        subscriberNo: state.esimQrCodeBlock.loginDetails.subscriberNo,
        appleUniversalLink: state.esimQrCodeBlock.qrCodeDetails.appleUniversalLink,
        androidUniversalLink: state.esimQrCodeBlock.qrCodeDetails.androidUniversalLink,
        isGetQrCodeError: state.esimQrCodeBlock.isGetQrCodeError,
        isLoadingQrCode: state.esimQrCodeBlock.isLoadingQrCode,
    };
};

const mapDispatchToProps = {
    goToPage,
    getQrCodeAsync,
    setIsGetQrCodeError,
    reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(InstallEsimOnMobilePage);
